/**
* ModeloPage component
* @returns <ModeloPage />
*/
import ItemDetailModelo from "../components/ItemDetailModelo";
import Breadcrumbs from "../components/Breadcrumbs";

import { useGetModelByIdQuery } from "../redux/apiSlice";
import { useLocation, useParams } from "react-router-dom";
import Loader from "../components/Loader";
import { AnimatePresence } from "framer-motion";

const ModeloPage = ({ financeOn }) => {
    // Get the location to use in the Breadcrumbs
    const location = useLocation();

    // Get the modeloId from the URL parameters
    const { modeloId } = useParams();

    // Fetch the model data by its ID using the custom Redux query
    const {
        data: modelById,
        isLoading,
        isFetching,
        isSuccess,
        isError
    } = useGetModelByIdQuery(modeloId)

    // Define the Breadcrumbs properties
    const BreadcrumbsProps = {
        links: [
            {
                link: "/",
                label: "Inicio"
            },
            {
                link: "..",
                label: location.pathname.split("/")[1]
            },
            {
                link: `../${location.pathname.split("/")[2]}`,
                label: modelById?.title
            }
        ],

        btnConfig: {
            tag: "link",
            text: "Volver a todos los modelos",
            color: "black",
            hasIcon: true,
            extraClass: "with-icon",
            url: "/modelos"
        }
    }

    return (
        <>
            {isLoading && (
                <AnimatePresence>
                    <Loader />
                </AnimatePresence>
            )}
            {isSuccess && (
                <>
                    <Breadcrumbs {...BreadcrumbsProps} />
                    <ItemDetailModelo item={modelById} financeOn={financeOn} />
                </>
            )
            }
            {isError && <p>Hubo un error</p>}
        </>
    )
}

export default ModeloPage